import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AddNode, ClearFilter, DeleteIcon, Edit, EditButtonIcon, FilterIcon, InfoIcon1, RemoveIcon, SaveFilter } from '../../../assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table'
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, Tooltip, Box, CircularProgress, TextField } from '@mui/material'
import { useHistory } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component'
import AlertTemplateMessage from '../../Configuration/AlertTemplate/AlertTemplateMessage'
import Swal from 'sweetalert2'
import EmergencyContactAdditionForm from './EmergencyContactAdditionForm'
import filtersConfig from '../Filters'
import { deleteEmergencyContactsBysite, getAllEmergencyContactList, getAllFilters } from '../../../services/configurationServices'
import { SuccessToast } from '../../../CustomHooks/SuccessToast'
import { ErrorToast } from '../../../CustomHooks/ErrorToast'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Typography,
  Divider,
} from '@mui/material';

const EmergencyContactConfig = () => {
    const history = useHistory();
    const wrapperRef = useRef(null);
    const [showAddSite, setShowAddSite] = useState(false);
    const [showBulkEditModal, setShowBulkEditModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showSavedFilterDeleteModal, setShowSavedFilterDeleteModal] = useState(false)
    const [openInfoFilter, setOpenInfoFilter] = useState(false)
    const [modalFilterName, setModalFilterName] = useState("")
    const [selected, setSelected] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [filterValues, setFilterValues] = useState({});
    const [filterData, setFilterData] = useState(null);
    const [emergencyContactData, setEmergencyContactData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [selectedZone, setSelectedZone] = useState(null)
    const [checked, setChecked] = useState([]);
    const [searchText, setSearchText] = useState('');


    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [globalFilter, setGlobalFilter] = useState('');

    const itemList = [
    { id: 1, label: 'Zone name 1' },
    { id: 2, label: 'Zone name 2' },
    { id: 3, label: 'Zone name 3' },
    { id: 4, label: 'Zone name 4' },
    { id: 5, label: 'Zone name 5' },
    { id: 6, label: 'Zone name 6' },
    { id: 7, label: 'Zone name 7' },
    { id: 8, label: 'Zone name 8' },
    { id: 9, label: 'Zone name 9' },
    { id: 10, label: 'Zone name 10' },
    { id: 11, label: 'Zone name 11' },
    { id: 12, label: 'Zone name 12' },
    { id: 13, label: 'Zone name 13' },
    { id: 14, label: 'Zone name 14' },
    { id: 15, label: 'Zone name 15' },
    ];

    const filteredList = itemList.filter(item =>
        item.label.toLowerCase().includes(searchText.toLowerCase())
    );

    const allChecked = filteredList.length > 0 && filteredList.every(item => checked.includes(item.id));
    const someChecked = filteredList.some(item => checked.includes(item.id)) && !allChecked;

    const handleToggle = (id) => () => {
        setChecked(prev =>
        prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const handleToggleAll = () => {
        if (allChecked) {
            setChecked(prev => prev.filter(id => !filteredList.some(item => item.id === id)));
        } else {
        const newIds = filteredList.map(item => item.id);
            setChecked(prev => [...new Set([...prev, ...newIds])]);
        }
    };

    // Enhanced configuration with extensible field mappings
    const getPageConfiguration = () => {
        const pageConfig = filtersConfig.find(config => config.pagename === 'EmergencyContactConfiguration');
        if (!pageConfig) {
            console.warn('EmergencyContactConfiguration not found in filters config');
            return { filters: {}, fieldMapping: {}, displayConfig: {} };
        }
        return pageConfig;
    };

    const pageConfig = getPageConfiguration();
    const pageFilters = pageConfig.filters;
    
    // Dynamic field mapping configuration - can be moved to external config
    const defaultFieldMapping = {
        'Customer': 'ClientName',
        'State': 'statename', 
        'City': 'City',
        'Site': 'SiteName',
        'Zone': 'ZoneName',
        'Interface': 'InterfaceName',
        'Device': 'DeviceName'
    };

    // Use configured field mapping or fall back to default
    const fieldMapping = pageConfig.fieldMapping || defaultFieldMapping;

    // Get the actual field name from configuration (with fallback to default mapping)
    const getFieldName = (filterKey) => {
        const filterConfig = pageFilters[filterKey];
        if (filterConfig && filterConfig.fieldName) {
            return filterConfig.fieldName;
        }
        return fieldMapping[filterKey] || filterKey;
    };

    // Get placeholder text from configuration
    const getPlaceholderText = (filterKey, filterConfig) => {
        if (filterConfig.placeholder) {
            return filterConfig.placeholder;
        }
        return `Select ${filterConfig.label}${filterConfig.mandatory ? '*' : ''}`;
    };
    
    // Excel-like Filter Utility - filters options based on other active selections
    const getFilteredOptions = (filterKey, optionKey, labelKey) => {
        if (!filterData || !filterData.Data) {
            return [];
        }

        // Build a filter object with only selected values for each filter (excluding current filter)
        const activeSelections = {};
        Object.keys(pageFilters).forEach(key => {
            const selected = filterValues[key];
            if (
                key !== filterKey &&
                Array.isArray(selected) &&
                selected.length > 0
            ) {
                activeSelections[key] = selected.map(item => 
                    typeof item === "object" ? item.value : item
                );
            }
        });

        // Filter data based on all other active selections
        const filtered = filterData.Data.filter(item => {
            return Object.entries(activeSelections).every(([key, selectedVals]) => {
                // Use the same field mapping logic as in getFilterOptions
                let fieldName;
                if (key === 'Customer') {
                    fieldName = 'ClientId';
                } else if (key === 'State') {
                    fieldName = 'statemasterid';
                } else if (key === 'City') {
                    fieldName = 'City';
                } else if (key === 'Site') {
                    fieldName = 'SiteID';
                } else if (key === 'Zone') {
                    fieldName = 'ZoneID';
                } else {
                    fieldName = getFieldName(key);
                }
                return selectedVals.includes(item[fieldName]);
            });
        });

        // Get unique options for this filter
        const seen = new Set();
        return filtered
            .filter(item => {
                const val = item[optionKey];
                if (!val || seen.has(val)) return false;
                seen.add(val);
                return true;
            })
            .map(item => ({
                label: item[labelKey],
                value: item[optionKey],
            }))
            .sort((a, b) => {
                // Sort options in ascending order by label
                return a.label.localeCompare(b.label, undefined, { 
                    numeric: true, 
                    sensitivity: 'base' 
                });
            });
    };

    // Create options from API filterData with Excel-like filtering - now fully dynamic
    const getFilterOptions = (filterKey) => {
        if (!filterData || !filterData.Data) {
            return [];
        }
        
        let optionKey, labelKey;
        
        if (filterKey === 'Customer') {
            // For Customer, use ClientId as value and ClientName as label
            optionKey = 'ClientId';
            labelKey = 'ClientName';
        } else if (filterKey === 'State') {
            // For State, use statemasterid as value and statename as label
            optionKey = 'statemasterid';
            labelKey = 'statename';
        } else if (filterKey === 'City') {
            // For City, use City as both value and label (no separate ID in your data)
            optionKey = 'City';
            labelKey = 'City';
        } else if (filterKey === 'Site') {
            // For Site, use SiteID as value and SiteName as label
            optionKey = 'SiteID';
            labelKey = 'SiteName';
        } else if (filterKey === 'Zone') {
            // For Zone, use ZoneID as value and ZoneName as label
            optionKey = 'ZoneID';
            labelKey = 'ZoneName';
        } else {
            // Fallback to field name for both (existing behavior)
            const fieldName = getFieldName(filterKey);
            optionKey = fieldName;
            labelKey = fieldName;
        }
        
        return getFilteredOptions(filterKey, optionKey, labelKey);
    };

    const handleFilterChange = (filterKey, value) => {
        if(filterKey == 'Customer' && value.length > 0) {
            setSelectedCustomer(value[0])
        }
        if(filterKey == "Zone" && value.length > 0){
            setSelectedZone(value[0])
        }
        setFilterValues(prev => {
            const newValues = {
                ...prev,
                [filterKey]: value
            };

            // Smart dependency clearing - clear dependent filters when parent changes
            const filterConfig = pageFilters[filterKey];
            if (filterConfig) {
                // Find and clear all dependent filters
                Object.entries(pageFilters).forEach(([key, config]) => {
                    if (config.parentFilter === filterKey) {
                        newValues[key] = [];
                        // Recursively clear dependencies
                        const clearDependencies = (parentKey) => {
                            Object.entries(pageFilters).forEach(([depKey, depConfig]) => {
                                if (depConfig.parentFilter === parentKey) {
                                    newValues[depKey] = [];
                                    clearDependencies(depKey);
                                }
                            });
                        };
                        clearDependencies(key);
                    }
                });
            }

            return newValues;
        });

        // Only reset table state when mandatory filters are changed
        const filterConfig = pageFilters[filterKey];
        if (filterConfig && filterConfig.mandatory) {
            // Reset table state when mandatory filters change
            setEmergencyContactData([]);
            setFiltersApplied(false);
            setRowSelection({});
            setPagination({
                pageIndex: 0,
                pageSize: 10,
            });
        }
    };

    // Enhanced validation with better error messaging
    const isMandatoryFiltersMissing = () => {
        return Object.entries(pageFilters).some(([filterKey, filterConfig]) => {
            return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
        });
    };

    // Get missing mandatory filters for better user feedback
    const getMissingMandatoryFilters = () => {
        return Object.entries(pageFilters)
            .filter(([filterKey, filterConfig]) => {
                return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
            })
            .map(([filterKey, filterConfig]) => filterConfig.label);
    };

    // Enhanced filter button tooltip
    const getFilterButtonTooltip = () => {
        const missingFilters = getMissingMandatoryFilters();
        if (missingFilters.length > 0) {
            return `Please select: ${missingFilters.join(', ')}`;
        }
        return "Apply Filter";
    };

    // Clear all filters function
    const handleClearAllFilters = () => {
        setFilterValues({});
        setEmergencyContactData([]);
        setFiltersApplied(false);
        setRowSelection({});
        setGlobalFilter('');
        setPagination({
            pageIndex: 0,
            pageSize: 10,
        });
    };

    // Handle global filter change with pagination reset
    const handleGlobalFilterChange = (value) => {
        setGlobalFilter(value);
        // Reset to first page whenever search changes
        setPagination(prev => ({
            ...prev,
            pageIndex: 0
        }));
    };

    // Apply filters function - now calls API and stores response
    const handleApplyFilters = async () => {
        if (!isMandatoryFiltersMissing()) {
            setLoading(true);
            setFiltersApplied(true);
            try {
                // Map filter values to API parameters
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const apiParams = {
                    UserID: user.UserID || '',
                    ClientID: '',
                    StateID: '',
                    CityID: '',
                    SiteID: '',
                    ZoneID: '',
                    Flag: 1
                };
                
                // Map filter values to API parameters
                Object.entries(filterValues).forEach(([filterKey, values]) => {
                    if (Array.isArray(values) && values.length > 0) {
                        const value = values[0].value;
                        if (filterKey === 'Customer') {
                            apiParams.ClientID = value;
                        } else if (filterKey === 'State') {
                            apiParams.StateID = value;
                        } else if (filterKey === 'City') {
                            apiParams.CityID = value;  // Note: Since City doesn't have a separate ID, this might need adjustment
                        } else if (filterKey === 'Site') {
                            apiParams.SiteID = value;
                        } else if (filterKey === 'Zone') {
                            apiParams.ZoneID = value;
                        }
                    }
                });

                const response = await getAllEmergencyContactList(apiParams);
                
                if (response && response.Status === 'success' && response.Data) {
                    setEmergencyContactData(response.Data);
                
                } else {
                    setEmergencyContactData([]);
                    console.warn('No emergency contact data received:', response);
                }
            } catch (error) {
                console.error('Error loading emergency contact data:', error);
                setEmergencyContactData([]);
            } finally {
                setLoading(false);
            }
        }
    };



    const columns = useMemo(() => {
        // Dynamic columns based on API response
        const dynamicColumns = [];
        
        if (emergencyContactData.length > 0) {
            const sampleData = emergencyContactData[0];
            
            // Define column mappings for better display names and formatting
            const columnMappings = {
                'ContactName': { header: 'Name', size: 250 },
                'EmailID': { header: 'Email', size: 300 },
                'Phone': { header: 'Mobile No', size: 200 },
                'SiteName': { header: 'Site Name', size: 240 },
                'CategoryName': {header: 'Category Name', size: 250 },
                'ContactLevel': { header: 'Level', size: 150 },
                'CreatedOn': { header: 'Created On', size: 150, isDate: true },
                'ModifiedOn': { header: 'Modified On', size: 150, isDate: true },
                'OrganizationMasterID': { header: 'Organization ID', size: 130 },
                'SMS': { header: 'SMS', size: 150 },
                'ClientName': { header: 'Client Name', size: 250 },
            };

            // Skip certain fields that shouldn't be displayed as columns
            const skipFields = ['CategoryID', 'ModifiedOn', 'CreatedOn', 'OrganizationMasterID', 'SiteID',
                'Email', 'InApp', 'IsCall', 'IsCustomerSPOC', 'IsERT', 'WhatsApp', 'SMS', 'EmergencyContactID',
                'ModifiedBy', 'CreatedBy', 'UpdatedateTime', 'UserID', 'SubscriptionArn', 'Designation', 'ClientId',
                'DeleteFlag', 'DeleteDateTime', 'LevelLimit', 'ClientName'
            ];

            // Create columns in the order defined by columnMappings
            Object.keys(columnMappings).forEach(key => {
                // Only add column if the field exists in the data and is not in skip list
                if (sampleData.hasOwnProperty(key) && !skipFields.includes(key)) {
                    const mapping = columnMappings[key];
                    const column = {
                        accessorKey: key,
                        header: mapping?.header || key.replace(/([A-Z])/g, ' $1').trim(),
                        size: mapping?.size || 150,
                        filterVariant: 'text',
                    };

                    // Special formatting for date columns
                    if (mapping?.isDate) {
                        column.Cell = ({ cell }) => {
                            const value = cell.getValue();
                            if (!value) return '-';
                            try {
                                return new Date(value).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                });
                            } catch {
                                return value;
                            }
                        };
                    }

                    // Special formatting for Category and Level
                    if (key === 'CategoryID') {
                        column.filterVariant = 'select';
                        column.filterSelectOptions = [
                            { text: 'Category 16', value: 16 },
                            { text: 'Category 17', value: 17 },
                            { text: 'Category 18', value: 18 },
                        ];
                    } else if (key === 'ContactLevel') {
                        column.filterVariant = 'select';
                        column.filterSelectOptions = [
                            { text: 'Level 1', value: 1 },
                            { text: 'Level 2', value: 2 },
                            { text: 'Level 3', value: 3 },
                        ];
                    }

                    dynamicColumns.push(column);
                }
            });

            // Add any remaining fields from sampleData that aren't in columnMappings (fallback)
            Object.keys(sampleData).forEach(key => {
                if (!skipFields.includes(key) && key !== 'actions' && !columnMappings[key]) {
                    dynamicColumns.push({
                        accessorKey: key,
                        header: key.replace(/([A-Z])/g, ' $1').trim(),
                        size: 150,
                        filterVariant: 'text',
                    });
                }
            });
        }

        // Always add actions column at the end
        dynamicColumns.push({
            accessorKey: "actions",
            header: "Actions",
            enableColumnActions: false,
            enableSorting: false,
            Cell: ({ row }) => (
                <div className="ActionBtns">
                    <Tooltip title="Edit" placement="bottom">
                        <button className="DataAccessEdit borderButton" onClick={() => showEmergencyContactForm(row.original)}>
                            <EditNoteIcon className="ActionsIcon" />
                        </button>
                    </Tooltip>

                    <Tooltip title="Delete" placement="bottom">
                        <button className="DataAccessEdit borderButton" onClick={e => onDeleteChange(e, row.original)}>
                            <DeleteForeverIcon className="ActionsIcon" />
                        </button>
                    </Tooltip>
                </div>
            ),
        });

        return dynamicColumns;
    }, [emergencyContactData]);

    const pagedData = useMemo(() => {
        let filteredData = emergencyContactData;
        
        // Apply global filter to complete dataset first
        if (globalFilter) {
            filteredData = emergencyContactData.filter(item => 
                Object.values(item).some(value => 
                    String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
                )
            );
        }
        
        // Then apply pagination to filtered data
        const start = pagination.pageIndex * pagination.pageSize;
        const end = start + pagination.pageSize;
        return filteredData.slice(start, end);
    }, [emergencyContactData, pagination, globalFilter]);

    // Get filtered count for pagination
    const filteredCount = useMemo(() => {
        if (!globalFilter) return emergencyContactData.length;
        
        return emergencyContactData.filter(item => 
            Object.values(item).some(value => 
                String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
            )
        ).length;
    }, [emergencyContactData, globalFilter]);

    useEffect(() => {
        // const fetchFilters = async () => {
        //   try {
        //     const response = await getAllFilters({ Entity: 'EmergencyContact' });
        //     setFilterData(response);
        //     console.log('EmergencyContact filter data loaded:', response);
        //   } catch (error) {
        //     console.error('Error loading emergency contact filters:', error);
        //     setFilterData(null);
        //   }
        // };
        
        fetchFilters();
    }, []);

    const fetchFilters = async () => {
        try {
            const response = await getAllFilters({ Entity: 'EmergencyContact' });
            setFilterData(response);
        } catch (error) {
            console.error('Error loading emergency contact filters:', error);
            setFilterData(null);
        }
    };

    const showSiteForm = () => {
        // history.push('/configuration/addsite');
        setShowAddSite(true);
    }

    const showEmergencyContactForm = (data) => {
        // history.push('/configuration/addEmergencyContact');
        setShowAddSite(true);
        setSelectedRow(data);
    }

    // Get selected emergency contact IDs from row selection
    const getSelectedEmergencyContactIds = () => {
        const selectedContactIds = Object.keys(rowSelection).filter(key => rowSelection[key]);
        return selectedContactIds;
    };

    const onBulkEditEmergencyContacts = () => {
        const selectedIds = getSelectedEmergencyContactIds();
        if (selectedIds.length === 0) {
            alert('Please select at least one emergency contact to edit.');
            return;
        }
        setShowBulkEditModal(true);
    };

    const onBulkDeleteEmergencyContact = (e) => {
        e.stopPropagation()
        const selectedIds = getSelectedEmergencyContactIds();
        if (selectedIds.length === 0) {
            alert('Please select at least one emergency contact to delete.');
            return;
        }
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete the selected emergency contacts?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete!"
        }).then((result) => {
            if (result.isConfirmed) {
                // Implement bulk delete logic here
                handleApplyFilters(); // Refresh data after deletion
            }
        })
    }

    const onDeleteChange = (e, row) => {
        e.stopPropagation();
        Swal.fire({
            title: "Are you sure?",
            text: `You really want to delete "${row.ContactName}" emergency contact!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteEmergencyContact(row.EmergencyContactID);
            }
        });
    }

    const deleteEmergencyContact = (contactId) => {
        try {
            let userId = localStorage.getItem("UserID");
            // Replace with actual delete API call
            deleteEmergencyContactsBysite(contactId)
                .then((res) => {
                    if(res.Status == "success") {
                        SuccessToast(res.Message);
                        handleApplyFilters();
                    }else{
                        ErrorToast(res.Message);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        } catch (error) {
            console.error('Error deleting emergency contact:', error);
        }
    };


    useEffect(() => {
        if (wrapperRef.current) {
            const labelEl = wrapperRef.current.querySelector(
                ".dropdown-heading .dropdown-heading-value"
            );
            if (labelEl) {
                const firstFilterKey = Object.keys(pageFilters)[0];
                const firstSelection = filterValues[firstFilterKey];
                const selectedLabel = firstSelection?.[0]?.label || "";
                const isTruncated = labelEl.scrollWidth > labelEl.clientWidth;
                labelEl.setAttribute("title", isTruncated ? selectedLabel : "");
            }
        }
    }, [filterValues]);

    // Generate filter summary for display
    const getFilterSummary = () => {
        const activeFilters = Object.entries(filterValues)
            .filter(([key, value]) => Array.isArray(value) && value.length > 0)
            .map(([key, value]) => {
                const config = pageFilters[key];
                const label = config ? config.label : key;
                const selectedLabel = value[0]?.label || value[0];
                return `${label}: ${selectedLabel}`;
            });
        
        return activeFilters.length > 0 ? activeFilters.join(' | ') : 'No filters applied';
    };
    return (
        <>
            <div className='p-3'>
                {showAddSite ? (
                   <EmergencyContactAdditionForm 
                       showAddSite={showAddSite} 
                       setShowAddSite={setShowAddSite} 
                       selectedRow={selectedRow} 
                       selectedCustomer={selectedCustomer} 
                       handleApplyFilters={handleApplyFilters} 
                       fetchFilters={fetchFilters} 
                       selectedZone={selectedZone}
                   />
                ) : (
                    <div className="SiteMainContainer SiteTableMainDiv">
                        <div className="DashboardFilterMainDiv">
                            <div className="RefreshText" style={{ display: "flex" }}>
                                {Object.entries(pageFilters)
                                    .sort(([, a], [, b]) => a.sequence - b.sequence)
                                    .map(([filterKey, filterConfig]) => (
                                        <div key={filterKey} className="inputTypeLabelContainer">
                                            <label className="formFieldLabels">
                                                {filterConfig.label}
                                                {filterConfig.mandatory && <span style={{ color: 'red' }}>*</span>}
                                            </label>
                                            <div ref={wrapperRef}>
                                                <MultiSelect
                                                    key={filterValues[filterKey]?.[0]?.value}
                                                    options={getFilterOptions(filterKey)}
                                                    value={filterValues[filterKey] || []}
                                                    onChange={(value) => handleFilterChange(filterKey, value.length > 1 ? [value[value.length - 1]] : value)}
                                                    labelledBy={`Select ${filterConfig.label}`}
                                                    hasSelectAll={false}
                                                    isCreatable={false}
                                                    disableSearch={false}
                                                    className="SiteConfigSingleSelectDropdownContainer"
                                                    overrideStrings={{
                                                        selectSomeItems:
                                                        (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                                            ? filterValues[filterKey][0].label
                                                            : getPlaceholderText(filterKey, filterConfig),
                                                        allItemsAreSelected:
                                                        (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                                            ? filterValues[filterKey][0].label
                                                            : getPlaceholderText(filterKey, filterConfig),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                <div className="HMFilterDiv">
                                    <Tooltip title={getFilterButtonTooltip()} placement="bottom">
                                        <button 
                                            className="IconsButtonDiv" 
                                            name="filterBtn"
                                            disabled={isMandatoryFiltersMissing() || loading}
                                            style={{ 
                                                opacity: (isMandatoryFiltersMissing() || loading) ? 0.5 : 1,
                                                cursor: (isMandatoryFiltersMissing() || loading) ? 'not-allowed' : 'pointer'
                                            }}
                                            onClick={handleApplyFilters}
                                        >
                                            <img
                                                src={FilterIcon}
                                                className="camera-icon-height"
                                                alt="Apply filter icon"
                                            />
                                        </button>
                                    </Tooltip>
                                    <Tooltip title="Clear Filter" placement="bottom">
                                        <button 
                                            className="IconsButtonDiv" 
                                            name="clearFilterBtn"
                                            disabled={loading}
                                            style={{ 
                                                opacity: loading ? 0.5 : 1,
                                                cursor: loading ? 'not-allowed' : 'pointer'
                                            }}
                                            onClick={handleClearAllFilters}
                                        >
                                            <img
                                                src={ClearFilter}
                                                className="camera-icon-height"
                                                alt="Clear filter icon"
                                            />
                                        </button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        <div className="SiteMainHeightDiv">
                            <div className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv" style={{ height: "calc(100vh - 290px)" }}>
                                <div className="card-body p-0">
                                    {loading ? (
                                        <Box 
                                            display="flex" 
                                            justifyContent="center" 
                                            alignItems="center" 
                                            minHeight="400px"
                                            flexDirection="column"
                                        >
                                            <CircularProgress size={60} thickness={4} />
                                            <Box mt={2}>
                                                <span style={{ fontSize: '16px', color: '#666' }}>Loading emergency contact data...</span>
                                            </Box>
                                        </Box>
                                    ) : emergencyContactData.length === 0 ? (
                                        <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                                            <AlertTemplateMessage
                                                message={
                                                    !filtersApplied || isMandatoryFiltersMissing()
                                                        ? "Please select mandatory filters and click apply filter to load emergency contact data"
                                                        : "No emergency contacts found for the selected filters"
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <MaterialReactTable
                                            columns={columns}
                                            data={pagedData}
                                            enableGlobalFilter={true}
                                            enableColumnFilters={false}
                                            enableStickyHeader
                                            enableColumnResizing={true}
                                            globalFilterFn="contains"
                                            columnResizeMode="onEnd"
                                            enableColumnOrdering={true}
                                            //enableRowSelection={true}
                                            muiTableHeadCellProps={{
                                                className: "myHeaderSelectAll",
                                            }}
                                            enableHiding={true}
                                            initialState={{ showColumnFilters: false }}
                                            manualPagination={true}
                                            manualFiltering={true}
                                            rowCount={filteredCount}
                                            getRowId={(row) => row.EmergencyContactID || row.ID || `row-${Math.random()}`}
                                            state={{
                                                pagination: pagination,
                                                rowSelection: rowSelection,
                                                globalFilter: globalFilter,
                                            }}
                                            onRowSelectionChange={setRowSelection}
                                            onPaginationChange={setPagination}
                                            onGlobalFilterChange={handleGlobalFilterChange}
                                            muiTableContainerProps={{
                                                className: "MaterialTableJs myTableContainer",
                                                sx: {
                                                    maxHeight: "100%",
                                                    overflow: "auto",
                                                },
                                            }}
                                            muiTableHeadProps={{
                                                className: "myHeader",
                                                sx: {
                                                    display: "table-header-group",
                                                },
                                            }}
                                            renderTopToolbarCustomActions={({ table }) => (
                                                <div className='d-flex justify-content-center align-items-center'>
                                                    <h4 style={{ margin: 0 }}>
                                                        List of emergency contacts {emergencyContactData.length > 0 && `(${emergencyContactData.length} records)`}
                                                    </h4>
                                                </div>
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='mb-2 mt-2'>
                            <Button 
                                className='m-1 ConfigBelowButtons' 
                                variant="contained" 
                                onClick={() => showEmergencyContactForm(null)}
                                disabled={!filtersApplied}
                                style={{ 
                                    cursor: (!filtersApplied) ? 'not-allowed' : 'pointer',
                                }}
                            >
                                Add Emergency Contact
                            </Button>
                            {/* <Button 
                                className='m-1' 
                                variant="contained" 
                                onClick={onBulkEditEmergencyContacts}
                                disabled={Object.keys(rowSelection).filter(key => rowSelection[key]).length === 0}
                            >
                                Bulk Edit {Object.keys(rowSelection).filter(key => rowSelection[key]).length > 0 && `(${Object.keys(rowSelection).filter(key => rowSelection[key]).length})`}
                            </Button> */}
                            {/* <Button className='m-1' variant="contained" onClick={onBulkDeleteEmergencyContact}>Bulk Delete</Button> */}
                        </div>
                    </div>
                )}
            </div>

            {/* Bulk Edit Modal */}
            <Modal
                show={showBulkEditModal}
                onHide={() => setShowBulkEditModal(false)}
                dialogClassName="widgetModelDiv"
                aria-labelledby="example-custom-modal-styling-title">
                <>
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            Emergency Contact Bulk Edit
                        </Modal.Title>
                        <img
                            src={RemoveIcon}
                            alt="Remove"
                            style={{ cursor: "pointer" }}
                            onClick={() => { setShowBulkEditModal(false) }}
                        />
                    </Modal.Header>

                    <Modal.Body>
                        <div className='SiteFormAdditionForm border-top-0'>
                            <form style={{ width: "100%" }}>
                                <div className="site-form">

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Contact name</label>
                                            <input
                                                className="inputType"
                                                placeholder="Enter Name*" />
                                            <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Email ID</label>
                                            <input
                                                className="inputType"
                                                placeholder="Enter Email ID*" />
                                            <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Mobile No.</label>
                                            <input
                                                className="inputType"
                                                placeholder="Enter Mobile No." />
                                            <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Select Category</label>
                                            <select
                                                className="inputType ArrowSelectClass"
                                                placeholder="Device Type*">
                                                <option key="0" disabled={false} value="0" id="0">Select Category*</option>
                                                <option>Category 1</option>
                                                <option>Category 2</option>
                                                <option>Category 3</option>
                                                <option>Category 4</option>
                                            </select>
                                            <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Select Level</label>
                                            <select
                                                className="inputType ArrowSelectClass"
                                                placeholder="Device Type*">
                                                <option key="0" disabled={false} value="0" id="0">Select Level*</option>
                                                <option>Level 1</option>
                                                <option>Level 2</option>
                                                <option>Level 3</option>
                                                <option>Level 4</option>
                                            </select>
                                            <p className="Error_P" style={{ float: "left" }}><span>{ }</span></p>
                                        </div>
                                    </div>                                   
                                </div>
                            </form>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <button
                                className="DataAccessEdit mt-3"
                                style={{ width: "100px" }}>
                                <span className="ViewUpdate">Submit</span>
                            </button>
                            <button onClick={() => setShowBulkEditModal(false)}
                                className="DataAccessEdit mt-3"
                                style={{ width: "100px" }}>
                                <span className="ViewUpdate">Cancel</span>
                            </button>
                        </div>
                    </Modal.Body>
                </>
            </Modal>

        </>
    )
}

export default EmergencyContactConfig